import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext';
import { aggregatePiecesRows } from '../lib/utils/aggregate';

export default function useSearch() {
  const [searchValue, setSearchValue] = useState('');
  const [term, setTerm] = useState('');
  const [searchResults, setSearchResults] = useState({});
  const { api } = useContext(AuthContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTerm(searchValue.trim().toLowerCase());
    }, 750);

    return () => {
      clearTimeout(timer);
    }
  }, [searchValue]);

  useEffect(() => {
    if (!term) return;
    const search = async () => {
      try {
        const response = await api.search(term);
        const { issues, authors, pieces } = response.data;
        setSearchResults({
          issues,
          authors,
          pieces: aggregatePiecesRows(pieces),
        });
      } catch (error) {
      }
    }
    search();
  }, [term, api]);

  return {
    searchValue,
    setSearchValue,
    searchResults,
  }
}
